import { ISlackDestinationFieldsFragment } from '../../../../utils/apollo/graphqlSchema';
import SlackDestinationLabel from '../../../../components/Slack/SlackDestinationLabel';
import { getSlackDestinationOption } from '../../../../components/Slack/utils';
import { IconWrapper, SvgIcon } from '../../../../components/Icon';
import KubitTooltip from '../../../../components/KubitTooltip';

interface IProps {
  slackDestination: ISlackDestinationFieldsFragment;
}

const SlackDestinationRecipient = ({ slackDestination }: IProps) => (
  <KubitTooltip
    placement="bottom"
    content={
      <SlackDestinationLabel
        value={getSlackDestinationOption(slackDestination)}
      />
    }
  >
    <IconWrapper size={20}>
      <SvgIcon name="slack-logo" />
    </IconWrapper>
  </KubitTooltip>
);

export default SlackDestinationRecipient;
